import { z } from 'zod';
import { SupportedTaxExemptionCountry } from 'store/shop';
import { claimsFiltersSchema } from './claims.schemas';

export const claimMismatches = ['expense', 'purchaseDate'] as const;
export type ClaimMismatch = (typeof claimMismatches)[number];

export const taxExemptionAnalysisStatuses = [
  'eligible',
  'nonEligible',
  'unsure',
] as const;
export type TaxExemptionAnalysisStatus =
  (typeof taxExemptionAnalysisStatuses)[number];

export const claimStatuses = [
  'pendingHRAction',
  'pendingEmployeeAction',
  'approved',
  'paid',
  'rejected',
] as const;
export type ClaimStatus = (typeof claimStatuses)[number];

export const claimTypes = ['claim', 'companyExpense'] as const;
export type ClaimType = (typeof claimTypes)[number];

export interface Claim {
  id: string;
  supplier: string;
  description: string;
  iban: string;
  sources: Array<{
    id: string;
    name: string;
  }>;
  admin: {
    id: string;
    fullName: string;
    email: string;
  };
  status: ClaimStatus;
  type: ClaimType;
  requestedAmount: number;
  approvedAmount: number;
  employee: {
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
  } | null;
  adminComment: string;
  files: Array<{ id: string; url: string; mime: string; name: string }>;
  purchasedAt: string;
  claimedAt: string;
  createdAt: string;
  updatedAt: string;
  expenseDate: string | null;
  taxExemptionAnalysis: {
    country: SupportedTaxExemptionCountry;
    status: TaxExemptionAnalysisStatus;
    summary: string;
    notes: string[];
    items: Array<{
      title: string;
      amount: number;
      status: TaxExemptionAnalysisStatus;
      reasons: string[];
    }>;
  } | null;
}

export type ClaimsFilters = z.infer<typeof claimsFiltersSchema>;
